import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { apiUrl } from '../utils/apiBase';
import { setAuthToken } from '../utils/auth-fetch';
import { useAuth } from './auth-context';

export const SignupPage: React.FC = () => {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      const res = await fetch(apiUrl('/api/auth/signup'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password, name }),
      });

      if (!res.ok) {
        setError(res.status === 409 ? 'Ten email jest już zarejestrowany.' : 'Nie udało się zarejestrować.');
        setSubmitting(false);

        return;
      }

      const data = (await res.json()) as { token: string };
      setAuthToken(data.token);
      await refresh();
      navigate('/me');
    } catch {
      setError('Błąd sieci.');
      setSubmitting(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-card" role="region" aria-label="Rejestracja">
        <span className="auth-card__score" aria-hidden="true">0 — 0</span>

        <header className="auth-card__head">
          <span className="auth-card__brand">
            <span className="auth-card__mark" aria-hidden="true">▾▴</span>
            Badminton<span className="auth-card__brand-accent">Arbiter</span>
          </span>
          <p className="auth-card__eyebrow">Załóż konto organizatora</p>
          <h1 className="auth-card__title">Rejestracja</h1>
        </header>

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="auth-field">
            <label htmlFor="signup-name" className="auth-field__label">
              <span className="auth-field__index">01</span> Imię i nazwisko
            </label>
            <input
              id="signup-name"
              type="text"
              autoComplete="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Jan Kowalski"
              required
            />
          </div>

          <div className="auth-field">
            <label htmlFor="signup-email" className="auth-field__label">
              <span className="auth-field__index">02</span> Email
            </label>
            <input
              id="signup-email"
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="ty@klub.pl"
              required
            />
          </div>

          <div className="auth-field">
            <label htmlFor="signup-password" className="auth-field__label">
              <span className="auth-field__index">03</span> Hasło
            </label>
            <input
              id="signup-password"
              type="password"
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>

          {error && (
            <p className="auth-error" role="alert" aria-live="assertive">
              {error}
            </p>
          )}

          <button type="submit" className="auth-submit" disabled={submitting}>
            {submitting ? 'Tworzę konto…' : 'Zarejestruj'}
          </button>
        </form>

        <p className="auth-card__alt">
          Masz konto? <Link to="/login">Zaloguj się</Link>
        </p>
      </div>
    </div>
  );
};
